<div class="crm-note-modal-container">
  <form #archiveForm="ngForm" (ngSubmit)="submit()">
    <div class="crm-modal-header py-2 px-3">
      <ng-container [ngSwitch]="crmItemType">
        <ng-container *ngSwitchCase="CrmItemType.STANDARD">
          {{ "CRM.ARCHIVE_MODAL.ARCHIVE_RECORD" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="CrmItemType.STRUCT_CAP">
          {{ "CRM.STRUCT_CAP.ARCHIVE_RECORD" | translate }}
        </ng-container>
      </ng-container>
      <span class="text-transform-none"> - {{ crmItem.name }}</span>
    </div>
    <div class="modal-body add-crm-note-body">
      <ng-container [ngSwitch]="crmItemType">
        <ng-container *ngSwitchCase="CrmItemType.STANDARD">
          <span class="bold">
            {{ "CRM.ARCHIVE_MODAL.CONFIRM" | translate }}
            <br>
            <br>
            You are about to <span class="dark-red">{{ "CRM.ARCHIVE_MODAL.ARCHIVE_LOWER" | translate }}</span> this Sonar record, {{ crmItem.name }}<ng-container *ngIf="crmItem.companies?.length > 0">, for {{ crmItem.companies[0].company.name }}</ng-container>.
            <br>
            {{ "CRM.ARCHIVE_MODAL.ARCHIVE_WARNING" | translate }}
          </span>
          <br>
          <br>
          - {{ "CRM.STATUS" | translate }}<br>
          - {{ "CRM.COURTSHIP" | translate }}<br>
          - {{ "CRM.STORM" | translate }}<br>
          - {{ "CRM.ETAKI" | translate }}<br>
          - {{ "CRM.DILIGENCE_LEAD" | translate }}<br>
          - {{ "CRM.DOMAIN" | translate }}<br>
          - {{ "CRM.PARTICIPANTS" | translate }}
          <br>
          <br>
          <div *ngIf="wakeAlarm">
            <div class="bold">
              {{ "CRM.ARCHIVE_MODAL.ARCHIVE_ALARM_WARNING" | translate }} {{wakeAlarm.trigger.value | rmsTzFormat: formatEST: 'MM/dd/yyyy'}}
            </div>
            <br>
          </div>
          <br>
          <div class="bold">
            {{ "CRM.ARCHIVE_MODAL.ARCHIVE_30_DAYS" | translate }}
          </div>
          <br>
          <label for="reason">
            {{ "CRM.ARCHIVE_MODAL.ARCHIVE_REASON" | translate }}<span class="red">*</span>
          </label>
        </ng-container>

        <ng-container *ngSwitchCase="CrmItemType.STRUCT_CAP">
          <div class="bold mb-3">
            {{ "CRM.ARCHIVE_MODAL.CONFIRM" | translate }}
            <br>
            <br>
            You are about to <span class="dark-red">{{ "CRM.STRUCT_CAP.ARCHIVE_LOWER" | translate }}</span> this Sonar record.
            <br>
            {{ "CRM.STRUCT_CAP.ARCHIVE_WARNING" | translate }}
          </div>
          <label for="reason">
            {{ "CRM.STRUCT_CAP.ARCHIVE_REASON" | translate }}<span class="red">*</span>
          </label>
        </ng-container>
      </ng-container>

      <textarea name="reason" id="reason" [(ngModel)]="archiveReason" class="form-control" placeholder="{{'CRM.STRUCT_CAP.ARCHIVE_NOTE_PLACEHOLDER' | translate}}" required></textarea>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="close()">
        {{"GENERICS.CANCEL" | translate}}
      </button>
      <button type="submit" class="btn button-red" [disabled]="archiveForm.invalid">
        {{ "CRM.ARCHIVE_MODAL.ARCHIVE" | translate }}
      </button>
    </div>
  </form>
</div>
